<template>
  <div class="numOfBusiness">
    <div class="title flex-between">
      <p>短信套餐详情</p>
      <div v-if="updateTime" class="time">更新时间：{{updateTime}}</div>
    </div>
    <el-table
      :data="smsPackageDetailList"
      size="small"
      style="width: 100%; margin-top: 10px"
      v-loading="loading"
      border
      >
      <el-table-column prop="smsMarketType" label="短信套餐类型" align="center" width="120"></el-table-column>
      <el-table-column prop="smsPackageTotal" label="短信套餐总条数" align="center" width="120"></el-table-column>
      <el-table-column prop="smsConsume" label="短信已消耗条数" align="center" width="120"></el-table-column>
      <el-table-column prop="smsBalance" label="短信余额条数" align="center" width="120"></el-table-column>
      <el-table-column prop="appPushStock" label="App push库存条数" align="center" width="130"></el-table-column>
      <el-table-column prop="pushSent" label="push已发条数" align="center" width="120"></el-table-column>
      <el-table-column prop="pushRemain" label="push剩余条数" align="center" width="120"></el-table-column>
      <el-table-column prop="effectiveTime" label="有效期时间" align="center" width="140"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getSmsPackageDetail } from '@/api/businessAnalysis'

export default {
  data () {
    return {
      loading: false,
      updateTime: '',
      smsPackageDetailList: []
    }
  },
  methods: {
    init () {
      this.getPageInfo()
    },
    async getPageInfo () {
      this.loading = true
      try {
        const { code, result } = await getSmsPackageDetail()
        if (code !== 200 || !result) return
        this.updateTime = result.updateTime || ''
        this.smsPackageDetailList = result.smsPackageDetailList || []
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url('../style/index.less');
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.time {
  font-size: 14px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
}
</style>